export function isVideoContent(src) {
  if (!src) return false;

  if (src.startsWith("blob:") || src.startsWith("data:")) {
    return false;
  }

  const IS_DEV = window.location.hostname === "localhost";
  if (IS_DEV) {
    return true;
  }

  const ext = src.split("?")[0].split(".").pop().toLowerCase();
  return ["mp4", "webm", "ogg"].includes(ext);
}
